import React from 'react';
import { withRouter } from 'react-router-dom';
import FieldModal from '../../../../components/modals/fieldModal';
import API from '../../../../utils/API';

class DeleteGroupModal extends React.Component {
    state = {
        submitting: false,
    };

    submit = async () => {
        const { attendee, eventId, orgId, group, attendeeGroups, addGroups, toggle } = this.props;

        const updatedGroups = attendeeGroups.filter(g => g._id !== group._id);
        const updatedGroupIds = updatedGroups.map(g => g._id);

        this.setState({ submitting: true });
        await API()
        .patch(`Organizations/${orgId}/events/${eventId}/attendees/${attendee._id}`, {
            groups: updatedGroupIds,
            request: 'updateGroups',
        })
        .then((res) => {
            if (res.data) {
                addGroups(updatedGroupIds);
                toggle();
            }
        })
        .catch((e) => {
            console.error(e);
            this.setState({ submitting: false });
        });
    };

    render() {
        const { isOpen, toggle, group } = this.props;
        const { submitting } = this.state;

        return (
            <FieldModal
                size="small"
                isOpen={isOpen}
                modalTitle={"Remove Group"}
                bodyContent={() => (
                    <div>
                        <p>
                            Are you sure you want to remove the group?
                        </p>
                    </div>
                )}
                toggle={toggle}
                actionButtonLabel={!submitting ? 'Remove' : 'Removing...'}
                actionButton={() => this.submit()} // Call submit instead of remove
                isDelete={true}
                actionButtonDisabled={submitting} // Prevent multiple clicks while submitting
            />
        );
    }
}

export default withRouter(DeleteGroupModal);
